"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const filter_1 = __importDefault(require("lodash/filter"));
const get_1 = __importDefault(require("lodash/get"));
const map_1 = __importDefault(require("lodash/map"));
const mobx_1 = require("mobx");
const getCustomerDriver_1 = __importDefault(require("../../clients/driver/getCustomerDriver"));
const API_STATE_1 = __importDefault(require("../../constants/app/API_STATE"));
const DOCUMENT_TYPES_1 = __importDefault(require("../../constants/document/DOCUMENT_TYPES"));
const documentFactory_1 = __importDefault(require("../../factories/document/documentFactory"));
const mapInitialStateToStoreState_1 = __importDefault(require("../../utils/store/mapInitialStateToStoreState"));
/**
 * Customer Driver Domain Store
 */
class CustomerDriverStore {
    constructor(initialState, $env) {
        this.data = {};
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        /**
         * Fetches customer register data from backend
         * @param errorHandler {function}
         */
        this.fetch = (0, mobx_1.flow)(function* (errorHandler) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = {};
                this.errorData = {};
                const response = yield (0, getCustomerDriver_1.default)();
                console.log('customer driver get response: ', response);
                this.onSuccess(response);
            }
            catch (err) {
                // all other http codes
                this.onError(err, errorHandler);
            }
        });
        /**
         * on success callback
         * @param data
         */
        this.onSuccess = (data) => {
            this.data = data;
            this.apiState = API_STATE_1.default.SUCCESS;
        };
        /**
         * on error callback
         * @param err
         * @param errorHandler
         */
        this.onError = (err, errorHandler) => {
            this.apiState = API_STATE_1.default.FAILED;
            // when a request is cancelled, Axios promise is rejected
            if (err.response) {
                const errResponse = err.response;
                const { data, status } = errResponse;
                // stores axios error info in observable
                this.errorData = {
                    data,
                    status,
                };
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * clear store on signout
         */
        this.onSignout = () => {
            this.data = {};
            this.apiState = API_STATE_1.default.INITIAL;
        };
        /**
         * Action to update driver info explicitly
         * This is after driver updates his info & calls update customer profile
         * the data auto updates in driver summary screen
         * @param updatedInfo
         */
        this.updateDriverInfo = (updatedInfo) => {
            // because the phone format in /customerprofile and /driver calls are different
            const mobileCode = (0, get_1.default)(updatedInfo, 'phone.code', 0);
            const mobileNumber = (0, get_1.default)(updatedInfo, 'phone.number', '');
            const dob = (0, get_1.default)(updatedInfo, 'dob', '');
            const hijrahDob = (0, get_1.default)(updatedInfo, 'hijrahDob', '');
            const isHijrahDob = !!hijrahDob;
            const dateObj = {
                dob: !isHijrahDob ? dob : '',
                hijrahDob: isHijrahDob ? hijrahDob : null,
            };
            this.data = Object.assign(Object.assign({}, this.data), updatedInfo);
            if (mobileNumber && mobileCode) {
                // we need to explicitly mutate for mobx autorun to work
                this.data = Object.assign(Object.assign(Object.assign({}, this.data), { countryCode: mobileCode, mobileNumber }), dateObj);
            }
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
    }
    /**
     * Returns the loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns if API fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns if API fetch has failed
     * @returns {Boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns current config language
     * @returns {Boolean}
     */
    get language() {
        return this.$env.config.locale;
    }
    /**
     * Returns first name of user
     */
    get firstName() {
        return (0, get_1.default)(this.data, 'firstName', '');
    }
    /**
     * Returns last name of user
     */
    get lastName() {
        return (0, get_1.default)(this.data, 'lastName', '');
    }
    /**
     * Returns full name of user
     */
    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
    /**
     * Returns the customer mobile code
     */
    get mobileCode() {
        return (0, get_1.default)(this.data, 'countryCode', 0);
    }
    /**
     * Returns the customer mobile number
     */
    get mobileNumber() {
        return (0, get_1.default)(this.data, 'mobileNumber', '');
    }
    /**
     * Returns the customer email
     */
    get email() {
        return (0, get_1.default)(this.data, 'email', '');
    }
    /**
     * Returns DOB of user
     */
    get dob() {
        return (0, get_1.default)(this.data, 'dob', '');
    }
    /**
     * Returns hijri DOB of user
     */
    get hijriDOB() {
        return (0, get_1.default)(this.data, 'hijrahDob', '');
    }
    /**
     * Returns true
     * if user have hijri date
     */
    get hasHijriDOB() {
        return !!this.hijriDOB;
    }
    /**
     * Returns title of user if available
     */
    get title() {
        return (0, get_1.default)(this.data, 'title', '');
    }
    /**
     * Returns address of driver
     * Right now BE sends only street address
     */
    get address() {
        return (0, get_1.default)(this.data, 'address.street', '');
    }
    /**
     * Returns nationality details of driver
     */
    get nationality() {
        return {
            code: (0, get_1.default)(this.data, 'nationality.code', 0),
            id: (0, get_1.default)(this.data, 'nationality.id', 0),
            country: (0, get_1.default)(this.data, `nationality.name.${this.language}`, ''),
        };
    }
    /**
     * Returns driver code
     */
    get driverCode() {
        return (0, get_1.default)(this.data, 'driverCode', '');
    }
    /**
     * Returns driver id
     */
    get driverId() {
        return (0, get_1.default)(this.data, 'id', 0);
    }
    /**
     * Returns formatted Document List
     * @returns {Array<DocumentFactoryType>}
     */
    get documentList() {
        const documents = (0, get_1.default)(this.data, 'documents', []);
        return (0, map_1.default)(documents, (document) => (0, documentFactory_1.default)(document));
    }
    /**
     * Returns formatted Passport List
     * @returns {Array<DocumentUploadType>}
     */
    get passportList() {
        return (0, filter_1.default)(this.documentList, (document) => {
            const documentType = (0, get_1.default)(document, 'type', '');
            return documentType === DOCUMENT_TYPES_1.default.PASSPORT;
        });
    }
    /**
     * Returns true if  driver has passport data
     */
    get hasPassort() {
        return this.passportList.length > 0;
    }
    /**
     * Returns formatted License List
     * @returns {Array<DocumentUploadType>}
     */
    get licenseList() {
        return (0, filter_1.default)(this.documentList, (document) => {
            const documentType = (0, get_1.default)(document, 'type', '');
            return documentType === DOCUMENT_TYPES_1.default.LICENSE;
        });
    }
    /**
     * Returns formatted National ID List
     * @returns {Array<DocumentUploadType>}
     */
    get nationalIdList() {
        return (0, filter_1.default)(this.documentList, (document) => {
            const documentType = (0, get_1.default)(document, 'type', '');
            return documentType === DOCUMENT_TYPES_1.default.NATIONAL_ID;
        });
    }
    /**
     * Returns true if  driver has NationalId data
     */
    get hasNationalId() {
        return this.nationalIdList.length > 0;
    }
    /**
     * Returns formatted Idama List
     * @returns {Array<DocumentUploadType>}
     */
    get iQamaList() {
        return (0, filter_1.default)(this.documentList, (document) => {
            const documentType = (0, get_1.default)(document, 'type', '');
            return documentType === DOCUMENT_TYPES_1.default.IQAMA;
        });
    }
    /**
     * Returns true if  driver has iQama data
     */
    get hasiQama() {
        return this.iQamaList.length > 0;
    }
    /**
     * Returns license details
     * @returns LicenseDetailsType
     */
    get licenseDetails() {
        const hijrahExpiry = (0, get_1.default)(this.licenseList[0], 'hijrahExpiry', ''); // eg. "10/06/1360"
        const hasHijrahExpiry = !!hijrahExpiry;
        return Object.assign(Object.assign({}, this.licenseList[0]), { // license details should only be 1
            hijrahExpiry,
            hasHijrahExpiry });
    }
    /**
     * Returns true if the driver  has atleast passport/nationalid,iqama details
     * & his license details added
     */
    get hasDocuments() {
        return ((this.passportList.length > 0 ||
            this.nationalIdList.length > 0 ||
            this.iQamaList.length > 0) &&
            this.licenseList.length > 0);
    }
    /**
     * Returns true if mobile number exists
     */
    get hasMobile() {
        return !!this.mobileNumber;
    }
    /**
     * Returns true if email exists
     */
    get hasEmail() {
        return !!this.email;
    }
    /**
     * Returns true if dob exists
     */
    get hasDob() {
        return !!this.dob;
    }
    /**
     * Returns true if first name and last name exists
     */
    get hasFullName() {
        return !!this.firstName && !!this.lastName;
    }
    /**
     * Returns the channel customer used to register
     * Can be email, mobile or others
     */
    get channel() {
        return (0, get_1.default)(this.data, 'channel', '');
    }
}
__decorate([
    mobx_1.observable
], CustomerDriverStore.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], CustomerDriverStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], CustomerDriverStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "language", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "firstName", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "lastName", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "fullName", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "dob", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "hijriDOB", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "hasHijriDOB", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "title", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "address", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "nationality", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "driverCode", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "driverId", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "documentList", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "passportList", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "hasPassort", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "licenseList", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "nationalIdList", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "hasNationalId", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "iQamaList", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "hasiQama", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "licenseDetails", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "hasDocuments", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "hasMobile", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "hasEmail", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "hasDob", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "hasFullName", null);
__decorate([
    mobx_1.computed
], CustomerDriverStore.prototype, "channel", null);
__decorate([
    mobx_1.action.bound
], CustomerDriverStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], CustomerDriverStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], CustomerDriverStore.prototype, "onSignout", void 0);
__decorate([
    mobx_1.action.bound
], CustomerDriverStore.prototype, "updateDriverInfo", void 0);
__decorate([
    mobx_1.action.bound
], CustomerDriverStore.prototype, "updateInitialState", void 0);
exports.default = CustomerDriverStore;
